import { cn } from '@/lib/utils'
import { ActionBarPrimitive } from '@assistant-ui/react'
import { IconV2CopyToClipboardOutline } from '@icons/IconV2CopyToClipboardOutline'
import { IconV2CorrectOutline } from '@icons/IconV2CorrectOutline'
import { IconV2RotateClockwiseOutline } from '@icons/IconV2RotateClockwiseOutline'

export function AssistantActionBar({ className }: { className?: string }) {
  return (
    <ActionBarPrimitive.Root
      hideWhenRunning
      autohide="never"
      autohideFloat="always"
      className={cn(
        'pointer-events-none flex gap-0.5 opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100',
        className
      )}
    >
      <ActionBarPrimitive.Copy className="group/copy flex size-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground">
        <IconV2CopyToClipboardOutline className="size-4 group-data-[copied]/copy:hidden" />
        <IconV2CorrectOutline className="hidden size-4 group-data-[copied]/copy:block" />
      </ActionBarPrimitive.Copy>
      <ActionBarPrimitive.Reload className="flex size-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground">
        <IconV2RotateClockwiseOutline className="size-4" />
      </ActionBarPrimitive.Reload>
    </ActionBarPrimitive.Root>
  )
}
